"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var Anchor = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "anchor" },
            react_1.default.createElement("path", { id: "Icon", d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11V13ZM2 12V11C1.73478 11 1.48043 11.1054 1.29289 11.2929C1.10536 11.4804 1 11.7348 1 12H2ZM22 12H23C23 11.4477 22.5523 11 22 11V12ZM19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13V11ZM14 5C14 6.10457 13.1046 7 12 7V9C14.2091 9 16 7.20914 16 5H14ZM12 7C10.8954 7 10 6.10457 10 5H8C8 7.20914 9.79086 9 12 9V7ZM10 5C10 3.89543 10.8954 3 12 3V1C9.79086 1 8 2.79086 8 5H10ZM12 3C13.1046 3 14 3.89543 14 5H16C16 2.79086 14.2091 1 12 1V3ZM13 22V8H11V22H13ZM5 11H2V13H5V11ZM1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782L5.63604 18.364C3.94821 16.6761 3 14.3869 3 12H1ZM4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23V21C9.61305 21 7.32387 20.0518 5.63604 18.364L4.22183 19.7782ZM12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782L18.364 18.364C16.6761 20.0518 14.3869 21 12 21V23ZM19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12H21C21 14.3869 20.0518 16.6761 18.364 18.364L19.7782 19.7782ZM22 11H19V13H22V11Z" }))));
};
exports.default = Anchor;
